import React from 'react';
import { Link } from 'react-router-dom';
import { useContent, resolveAsset } from '../contexts/ContentContext';
import ProductGrid from './ProductGrid';

const mapDb = (p) => ({
  id: p.id,
  type: p.type,
  name: p.name,
  description: p.description,
  technique: p.embroidery || 'Bespoke',
  material: p.fabric || 'Pure Silk',
  hours: 200,
  image: resolveAsset(p.image),
});

/**
 * SuitCollection — homepage section mirroring <Collection /> but for
 * products of type='suit'. Cards route to /archive/<id> (suits live inside
 * the Collection page) and the View-all CTA jumps to the Bespoke Suits tab.
 * Section copy is editable from Admin → Pages → "Home — Suit Collection".
 */
const SuitCollection = ({ onInquire }) => {
  const { products, content } = useContent();
  const section = content['home.suits'] || {};

  const suits = products.filter((p) => p.type === 'suit');
  // Featured first, then non-featured fill — so every uploaded suit appears (capped at 8).
  const featuredSuits = suits.filter((p) => p.featured);
  const rest = suits.filter((p) => !p.featured);
  const items = [...featuredSuits, ...rest].slice(0, 8).map(mapDb);

  if (items.length === 0) return null;

  return (
    <section
      id="suit-collection"
      className="section-padding"
      style={styles.section}
      data-testid="suit-collection-section"
    >
      <div className="luxury-container">
        <div style={styles.sectionHeader}>
          <p style={styles.sectionLabel}>{section.eyebrow || 'The Suit Atelier'}</p>
          <h2 className="heading-1">{section.title || 'Bespoke Suits'}</h2>
          <p className="body-large" style={styles.sectionDescription}>
            {section.description ||
              'Tailored statement pieces \u2014 anarkalis, sharara sets, and contemporary suits, each hand-finished with heritage technique.'}
          </p>
        </div>

        <ProductGrid
          items={items}
          variant="collection"
          onInquire={onInquire}
          testIdPrefix="suits"
        />

        <div style={styles.ctaWrap}>
          <Link
            to="/archive?type=suit"
            className="btn-secondary"
            data-testid="suits-view-all"
          >
            {section.viewAllText || 'View All Suits'}
          </Link>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: 'var(--bg-secondary)',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  sectionLabel: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '16px',
  },
  sectionDescription: {
    maxWidth: '600px',
    margin: '16px auto 0',
  },
  ctaWrap: {
    marginTop: '32px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export default SuitCollection;
